require("bundle-loader!./entry.js")(function(fileJsExports) {
  window.dispatchEvent(new CustomEvent('XarticleForumLoaded'));
});
